import { cn } from '@/lib/utils';

/**
 * Shared Tailwind classes for rendering Markdown output from AI responses.
 * Used by ChatInterface and AIOutput.
 */
export const markdownClasses = cn(
  'prose prose-sm max-w-none dark:prose-invert',
  'prose-headings:text-foreground prose-p:text-foreground',
  'prose-strong:text-foreground prose-em:text-foreground',
  'prose-code:text-foreground prose-code:bg-muted prose-code:px-1 prose-code:py-0.5 prose-code:rounded',
  'prose-pre:bg-muted prose-pre:text-foreground',
  'prose-a:text-primary',
  'prose-li:text-foreground',
  'prose-p:my-1 prose-headings:my-2',
);
